import { BlogFormValues } from "context/BlogContext";
import React from "react";

interface BlogInfoProps {
  blog: BlogFormValues;
}

const PreviewBlogInfo: React.FC<BlogInfoProps> = ({ blog }) => {
  //  - 
  // ${new Date(
  //   blog.createdAt
  // ).toLocaleDateString("en-US", {
  //   year: "numeric",
  //   month: "short",
  //   day: "numeric",
  //   timeZone: "Asia/Kolkata",
  // })}
  return (
    <div className="">
      <p className="flex font-semibold text-2xl">{blog.title}</p>
      <div className="flex items-center pt-3 gap-x-3">
        <div className="w-[40px] h-[40px] rounded-full overflow-hidden">
          <img src={blog?.authorId?.image} className="h-full w-full" />
        </div>
        <p>{`by ${blog?.authorId?.name}`}</p>
      </div>
      <div className="flex justify-center pt-5">
        <img className="rounded-md w-full h-auto" src={blog.coverImage} />
      </div>
    </div>
  );
};

export default PreviewBlogInfo;
